import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { TextInputProps, ViewStyle } from 'react-native';
import styled from '@2pulse/responsive';
import { SvgEdit } from '../icons/SvgEdit';
import { normalize } from '@app/helpers';
import { row } from '@app/style';

interface SelectProps extends TextInputProps {
  name: string;
  inside?: boolean;
}

const InputContainer = styled.View(({ theme }) => ({
  ...row,
  height: normalize(76),
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const InputFirstAction = styled.TouchableOpacity<{ inside?: boolean }>(({ theme, props }) => ({
  flexGrow: 1,
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: normalize(34),
  paddingRight: normalize(21),
  borderTopLeftRadius: props.inside ? 0 : 5,
  borderBottomLeftRadius: props.inside ? 0 : 5,
  backgroundColor: 'rgba(240, 249 , 252, .04)',
}));

const InputSecondAction = styled.TouchableOpacity<{ inside?: boolean }>(({ theme, props }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: normalize(21 + 34 + 21),
  backgroundColor: 'rgba(240, 249 , 252, .04)',
  borderTopRightRadius: props.inside ? 0 : 5,
  borderBottomRightRadius: props.inside ? 0 : 5,
  marginLeft: normalize(2),
}));

const InputLabel = styled.Text(({ theme }) => ({
  fontSize: normalize(21),
  color: theme.colors.babypowder,
}));

const InputIconFrame = styled.View(({ theme }) => ({
  width: normalize(34),
  height: normalize(34),
}));

export const InputDouble = ({ inside, name }: SelectProps) => {
  return (
    <InputContainer>

      <InputFirstAction inside={inside}>
        <InputLabel>{name}</InputLabel>
        <InputIconFrame>
          <SvgEdit color="#fff" />
        </InputIconFrame>
      </InputFirstAction>

      <InputSecondAction inside={inside}>
        <InputIconFrame>
          <SvgEdit color="#fff" />
        </InputIconFrame>
      </InputSecondAction>

    </InputContainer>
  );
};
